// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price__ExactPrice(props) {
  let price = props.price;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, props.draft);
  let match = draft.draftProperty.propertyType;
  let tmp;
  tmp = match === "FOR_SALE" ? "Price" : "Rent/month";
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      widthMd: 4,
      children: [
        JsxRuntime.jsx(Form__Input.make, {
          labelText: tmp,
          onChange: event => price.onChange(Form__Helpers.intFromFormattedPrice(event)),
          onBlur: param => price.onBlur(),
          onFocus: param => price.onFocus(),
          status: price.status,
          prepend: "$",
          value: Form__Helpers.intOptToFormattedPrice(price.value)
        }),
        JsxRuntime.jsx(Form__Components.FieldError.make, {
          valid: price.valid
        })
      ]
    })
  });
}

let Components;

let FormSection;

let TextInputField;

let Cell;

let FormUtils;

let Validators;

let make = PropertyWizardRelay__KeyFacts__Price__ExactPrice;

exports.Components = Components;
exports.FormSection = FormSection;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.FormUtils = FormUtils;
exports.Validators = Validators;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Form__Input Not a pure module */
